<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("weekends") }}</div>
      <div>
        <router-link
          v-if="$can('create', 'Weekends')"
          class="btn-blue"
          to="add-weekends"
          >{{ $t("add") }}</router-link
        >
        <button
          v-if="$can('update', 'Weekends')"
          :disabled="!selectedCinema"
          class="btn-blue"
          @click.prevent.stop="gotoRoute()"
        >
          {{ $t("edit") }}
        </button>
      </div>
    </div>

    <div class="white-wrapper mt-5">
      <div class="row align-items-top">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="selectedCinema.length == 0"
                >Please Select Cinema.</span
              >
            </p>
          </div>
        </div>
      </div>

      <table class="list-view-table">
        <thead>
          <tr>
            <th class="" style="width: 200px;">{{ $t("days") }}</th>
            <th class="text-left">
              <span class="pr-4">{{ $t("weekends") }}</span>
            </th>
          </tr>
        </thead>

        <tbody v-if="WeekendList.length > 0">
          <tr>
            <td>Sunday</td>
            <td class="text-left">
              <span v-if="WeekendList[0].week_end_sunday == 'Y'" class="pr-4"
                >Yes</span
              >
              <span v-else class="pr-4">No</span>
            </td>
          </tr>
          <tr>
            <td>Monday</td>
            <td class="text-left">
              <span v-if="WeekendList[0].week_end_monday == 'Y'" class="pr-4"
                >Yes</span
              >
              <span v-else class="pr-4">No</span>
            </td>
          </tr>
          <tr>
            <td>Tuesday</td>
            <td class="text-left">
              <span v-if="WeekendList[0].week_end_tuesday == 'Y'" class="pr-4"
                >Yes</span
              >
              <span v-else class="pr-4">No</span>
            </td>
          </tr>
          <tr>
            <td>Wednesday</td>
            <td class="text-left">
              <span v-if="WeekendList[0].week_end_wednesday == 'Y'" class="pr-4"
                >Yes</span
              >
              <span v-else class="pr-4">No</span>
            </td>
          </tr>
          <tr>
            <td>Thursday</td>
            <td class="text-left">
              <span v-if="WeekendList[0].week_end_thurday == 'Y'" class="pr-4"
                >Yes</span
              >
              <span v-else class="pr-4">No</span>
            </td>
          </tr>
          <tr>
            <td>Friday</td>
            <td class="text-left">
              <span v-if="WeekendList[0].week_end_friday == 'Y'" class="pr-4"
                >Yes</span
              >
              <span v-else class="pr-4">No</span>
            </td>
          </tr>
          <tr>
            <td>Saturday</td>
            <td class="text-left">
              <span v-if="WeekendList[0].week_end_saturday == 'Y'" class="pr-4"
                >Yes</span
              >
              <span v-else class="pr-4">No</span>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="2">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      iscindeID: true,
      isRoleID: true,
      submitted: false,
      msgcinema: "",
      selectedCinema: "",
      cineid: "",
      CinemasList: [],
      WeekendList: [],
      CinemasListCopy: [],
      searchCinema: "",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.iscindeID = true;
      this.getAllActiveCinemas(obj);
    } else {
      this.iscindeID = true;
      this.getAllActiveCinemas(obj);
    }
    // this.getviewingnumber();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.cineid = CinemaObj.cine_id;
      this.getWeekendList(CinemaObj.cine_id);
    }
  },
  methods: {
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.CinemasList = this.CinemasListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CinemasList = this.CinemasListCopy;
      }
    },
    gotoRoute: function () {
      this.$router.push({
        path: "/cinema-manager/edit-weekends",
        query: { c_id: this.cineid },
      });
    },

    getAllActiveCinemas: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
            this.CinemasListCopy = data.Records;
            this.CinemasList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };
                this.iscindeID = false;
                this.onSelectCinema(event, cinema);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveCinemas :", error);
        });
    },

    onSelectCinema: function (event, cinema) {
      this.selectedCinema = cinema.cine_name;
      this.cineid = cinema.cine_id;
      this.iscindeID = false;
      this.getWeekendList(cinema.cine_id);
      (this.searchCinema = ""), this.onSearchCinema(null);
      this.$store.dispatch("selectDropdownCinema", cinema);
    },

    getWeekendList: function (cine_id) {
      MasterService.GetWeekendsList(cine_id).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.WeekendList = data.Records;
          }
        } else {
          this.$toasted.show(data.message);
          this.WeekendList = [];
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/WeekendsComponents/weekends.vue